module.exports = __webpack_public_path__ + "img/anim-pasto.55924e19.jpg";